export class FeedbackFormConstants {
}
FeedbackFormConstants.PROBABILITY_OF_SHOWING_FEEDBACK_FORM = 0.1;
FeedbackFormConstants.DAYS_BETWEEN_FEEDBACK_FORMS = 90;
